import Splide from '@splidejs/splide';

const ImageSlideshow = {
    init() {
        this.sliders = [];
        document.querySelectorAll('[data-image-slideshow]').forEach((root) => {
            this.sliders.push(this.createSlider(root));
        });
    },

    createSlider(root) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        const splide = new Splide(root, {
            type: 'slide',
            perPage: 1,
            pagination: true,
            arrows: false,
            speed: reduceMotion ? 0 : 500,
            drag: !reduceMotion,
            i18n: {
                slideX: 'Go to slide %s',
            },
        });

        splide.mount();
        return splide;
    },
};

export default ImageSlideshow;
